// types
import { createSlice } from "@reduxjs/toolkit";

export interface MenuState {
  openItem: string[];
  defaultId: string;
  openComponent: string;
  drawerOpen: boolean;
  componentDrawerOpen: boolean;
}

const DEFAULT_STATE: MenuState = {
  openItem: [],
  defaultId: "",
  openComponent: "buttons",
  drawerOpen: false,
  componentDrawerOpen: true,
};

const menuSlice = createSlice({
  name: "menuSlice",
  initialState: DEFAULT_STATE,
  reducers: {
    activeItem(state, action) {
      state.openItem = action.payload.openItem;
    },

    activeComponent(state, action) {
      state.openComponent = action.payload.openComponent;
    },

    openDrawer(state, action) {
      state.drawerOpen = action.payload.drawerOpen;
    },

    openComponentDrawer(state, action) {
      state.componentDrawerOpen = action.payload.componentDrawerOpen;
    },
  },
});

export const menuReducer = menuSlice.reducer;
export const menuActions = menuSlice.actions;
